import React , { Component } from 'react';
import HOC from './HOC';
import InputText from '../components/formulario/InputText';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import CalendarioRango from '../components/formulario/CalendarioRango';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-responsive-modal';
import { obtenerRemesas } from '../../service/actions';
import $ from 'jquery';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css'
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';

class Reportediario extends Component {
    state = {
        mostrarModal    : false,
        isLoading       : false,
        m_modal         : '',
         casoModal: '',
        pagination: 10,
        pages: 0,
        page: 0,
        filtered: [],
        open: false,
        disableDiv: false,
        idremesa: '',
        //Agregando Nuevo
        pagoFacil: '',
        numeroDocumentoCobro: '',
        codigoProducto: '',
        poliza: '',
        tipoDocumento: '',
        numeroDocumento: '',
        aseguradoNombre: '',
        aseguradoApellido: '',
        fechaInicial: '',
		fechaFinal: '',
		estadoRemesa: '',
        banco: '',
        canal: '',
        subcanal: '',
		riesgo: '',
        usuario: '',
        sortedColumn:'',
        sortedOrder:'',

        v_pagoFacil: '',
        v_numeroDocumentoCobro: '',
        v_codigoProducto: '',
        v_poliza: '',
        v_tipoDocumento: '',
        v_numeroDocumento: '',
        v_aseguradoNombre: '',
        v_aseguradoApellido: '',
		v_fecha: '',
		v_estadoRemesa: '',
        v_banco: '',
        v_canal: '',
        v_subcanal: '',

		v_riesgo: '',

        listaTipoDocumentos: [
            {
                value: "1",
                detalle: 'RUC'
            },
            {
                value: "2",
                detalle: 'DNI'
            },
            {
                value: "3",
                detalle: 'NIT'
            },
            {
                value: "4",
                detalle: 'CARNET DE EXTRANJERIA'
            },
            {
                value: "5",
                detalle: 'CARNET DE IDENTIDAD'
            },
            {
                value: "6",
                detalle: 'PASAPORTE'
            },
            {
                value: "7",
                detalle: 'LIBRETA MILITAR'
            },
            {
                value: "8",
                detalle: 'DPI'
            },
            {
                value: "9",
                detalle: 'CODIGO INTERNO'
            },
            {
                value: "10",
                detalle: 'IDENT. MENOR DE EDAD'
            },
            {
                value: "11",
                detalle: 'IDENT. EMP. EXT.'
            },
		],
		listaEstadoRemesa: [
            {
                value: "COB",
                detalle: 'Cobrado'
            },
            {
                value: "INC",
                detalle: 'Pendiente'
            }
		],
        listaBancos: [
            {
                value: "BANCO DE CREDITO DEL PERU",
                detalle: 'BANCO DE CREDITO DEL PERU'
            },
            {
                value: "SCOTIABANK PERU SAA",
                detalle: 'SCOTIABANK PERU SAA'
            },
            {
                value: "BBVA BANCO CONTINENTAL",
                detalle: 'BBVA BANCO CONTINENTAL'
            },
            {
                value: "COMPAÑIA PERUANA DE MEDIOS DE PAGO S.A.C",
                detalle: 'COMPAÑIA PERUANA DE MEDIOS DE PAGO S.A.C'
            },
            {
                value: "BANCO INTERNACIONAL DEL PERU-INTERBANK",
                detalle: 'BANCO INTERNACIONAL DEL PERU-INTERBANK'
            },
            {
                value: "DINERS CLUB PERU S A",
                detalle: 'DINERS CLUB PERU S A'
            },
            {
                value: "BANCO INTERAMERICANO DE FINANZAS",
                detalle: 'BANCO INTERAMERICANO DE FINANZAS'
            },
            {
                value: "CIA DE SERVICIOS CONEXOS EXPRESSNET SAC",
                detalle: 'CIA DE SERVICIOS CONEXOS EXPRESSNET SAC'
            },
            {
                value: "PROCESOS DE MEDIOS DE PAGO S.A.",
                detalle: 'PROCESOS DE MEDIOS DE PAGO S.A.'
            },
            {
                value: "BANCO PICHINCHA",
                detalle: 'BANCO PICHINCHA'
            },
            {
                value: "BANCO DE COMERCIO",
                detalle: 'BANCO DE COMERCIO'
            },
            {
                value: "CIA. PERUANA DE MEDIOS DE PAGO S.A.C.",
                detalle: 'CIA. PERUANA DE MEDIOS DE PAGO S.A.C.'
            } 
        ],
        listaCanal: [
            {
                value: "CORREDOR",
                detalle: 'CORREDOR'
            },
            {
                value: "DIRECTO",
                detalle: 'DIRECTO'
            },
            {
                value: "FUERZA DE VENTAS",
                detalle: 'FUERZA DE VENTAS'
            },
            {
                value: "NO TRADICIONAL",
                detalle: 'NO TRADICIONAL'
            },
        ],
        listaSubCanal: [
            {
                value: "ALTERNATIVOS",
                detalle: 'ALTERNATIVOS'
            },
            {
                value: "BANCA TRADICIONAL",
                detalle: 'BANCA TRADICIONAL'
            },
            {
                value: "CENTRIA",
                detalle: 'CENTRIA'
            },
            {
                value: "CGDC",
                detalle: 'CGDC'
            },
            {
                value: "CHATBOT CALL",
                detalle: 'CHATBOT CALL'
            },
            {
                value: "CHATBOT WEB",
                detalle: 'CHATBOT WEB'
            },
            {
                value: "CLINICAS",
                detalle: 'CLINICAS'
            },
            {
                value: "COMERCIALIZADORES",
                detalle: 'COMERCIALIZADORES'
            },
            {
                value: "DIRECTO",
                detalle: 'DIRECTO'
            },
            {
                value: "ENTIDADES FINANCIERAS",
                detalle: 'ENTIDADES FINANCIERAS'
            },
            {
                value: "ESTRATEGICOS",
                detalle: 'ESTRATEGICOS'
            },
            {
                value: "FFVV DE RENTAS VITALICIAS",
                detalle: 'FFVV DE RENTAS VITALICIAS'
            },
            {
                value: "FFVV MULTISEGUROS",
                detalle: 'FFVV MULTISEGUROS'
            },
            {
                value: "FFVV SALUD",
                detalle: 'FFVV SALUD'
            },
            {
                value: "FFVV VIDA",
                detalle: 'FFVV VIDA'
            },
            {
                value: "LEASING",
                detalle: 'LEASING'
            },
            {
                value: "MASIVO",
                detalle: 'MASIVO'
            },
            {
                value: "MODULO VENTA",
                detalle: 'MODULO VENTA'
            },
            {
                value: "NO DETERMINADO",
                detalle: 'NO DETERMINADO'
            },
            {
                value: "PLATAFORMA",
                detalle: 'PLATAFORMA'
            },
            {
                value: "PROVINCIAS",
                detalle: 'PROVINCIAS'
            },
            {
                value: "RENTA VITALICIA",
                detalle: 'RENTA VITALICIA'
            },
            {
                value: "TELEMARKETING",
                detalle: 'TELEMARKETING'
            },
            {
                value: "VIP",
                detalle: 'VIP'
            },
            {
                value: "WEB",
                detalle: 'WEB'
            },
            {
                value: "WEB RRVV",
                detalle: 'WEB RRVV'
            },
            {
                value: "WEB VIDA",
                detalle: 'WEB VIDA'
            },
            {
                value: "WEBCALL",
                detalle: 'WEBCALL'
            },
            {
                value: "WORKSITE",
                detalle: 'WORKSITE'
            },
            {
                value: "WORKSITE ELITE",
                detalle: 'WORKSITE ELITE'
            } 
        ],
		listaRiesgo: [
            {
                value: "RG",
                detalle: 'Riesgos Generales'
            },
            {
                value: "VI",
                detalle: 'Vida'
            }
		],
		
        //
        cantidadRemesas:0,
        listaRemesas: this.props.listaRemesas,
        paginacion:[],
        listaDetalleRemesas:[],
        formValido: true,
        nohayremesas:false,
        buscadorMobile: "",
        intervalId: "",
    }

    disableDiv = () => {
        this.setState({
           disableDiv:true
        });
    }

    enableDiv = () => {
        this.setState({
           disableDiv:false
        });
    }

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onOpenModal = (remesaId) => (e)  => {
        let request = { 
            remesaId: remesaId
        };
        this.props.mostrarLoading();
        this.props.props.callService("GET","remesas", {...request}, obtenerRemesas).then(response => {
             console.log("response de remesas por IDDD:::::",response);
            if(response){
                if (response.data.status == 406){
                     console.log("error de 40666666:::::");
                    this.setState({ open: false, idremesa: remesaId});
                    this.props.ocultarLoading();
                    this.props.mostrarModal('mensaje', null, 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
                    new Promise((resolve, reject) => {
                        setTimeout(function(){
                        //localStorage.clear();
                        Auth.signOut();
                        resolve(true);
                        },1500);
                
                    }).then(() => {
                        const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
                        const urlRedirect = window.location.href.substring(0, indexURL);
                        window.location.href = urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
                    });
                }else if(200 === response.status){    
                    let detalleremesasFinalizadas = [];
                    if(Object.values(response.data.listaremesas).length > 0){
                        Object.values(response.data.listaremesas).map(item => {
                            Object.values(item).map(dato => {
                                detalleremesasFinalizadas.push(dato);
                                return detalleremesasFinalizadas;
                            })
                            return item;
                        });
                    }
                    this.setState({ listaDetalleRemesas: Object.values(detalleremesasFinalizadas) });
                    this.props.ocultarLoading();
                    this.setState({ open: true, idremesa: remesaId});
                }
                
            }
            else if(response === undefined)
            {
                this.props.ocultarLoading();
                this.cerrarSesion();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.setState({ open: true, idremesa: remesaId});
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    };

    onCloseModal = ()  => {
        this.setState({ open: false, listaDetalleTransacciones: [] });
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
      getLocalStorage = (key) => {
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }
        
      }

    componentWillMount() {
    }

    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }
        let bancos = localStorage.getItem("bancos") ? JSON.parse(localStorage.getItem("bancos")) : this.state.listaBancos;
        this.setState({
            fechaInicial: localStorage.getItem("fechaInicial"),
            fechaFinal : localStorage.getItem("fechaFinal"),
            listaBancos: bancos
        });

       

        //var intervalId = setInterval(this.timer.bind(this), 5000);
        //this.setState({intervalId: intervalId});
        Auth.currentUserInfo().then(response => {
          // console.log(response);
            if (response && response.attributes != null){
              this.setState({
                usuario: response && response.attributes.email ? response.attributes.email : ''
              });
            }
        });

    }

    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }

    validarFormulario = (e) => {
        let { value , name } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value)}, () => {
            this.setState({formValido : Utils.validarFormState(this.state, 'filtro')})
        })   
    }

    onChange = (e) => {
        let { name, value } = e.target;    
        
        if( "ideDireccion" === name ){
            this.setState({
                [name]: value.split(CONSTANTES.SEPARADOR)[0],
                formValido: true,
                ["dsc"+name.substring(3, name.length)] :  value.split(CONSTANTES.SEPARADOR)[1],
            }, () => {
            });
        }
        else if("numeroDocumentoCobro" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else if("pagoFacil" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else if("codigoProducto" === name)
        {
            const re = /^[0-9\b]+$/;
            if (value === '' || re.test(value)) {
                this.setState({ [name] : value });
            }
        }
        else{
            this.setState({ [name] : value }, () => {
            });
        }
    }

    handleChange = (e) => {
        let { name, value } = e.target; 
        this.setState({loteId: e.target.value})
        this.setState({ [name] : value }, () => {
        });
        if(e.target.value !== "")
        {
            $("#calendarPortalCobranzas").css("display", "none");
        } else{
            $("#calendarPortalCobranzas").css("display", "block");
        }
      } 

    /** OBTENER REMESAS */
    obtenerRemesas = (params) => {
        this.props.mostrarLoading();
        this.props.props.callService("GET","remesas", {...params}, obtenerRemesas).then(response => {
            // console.log(response);
            if(response){
                console.log(response);
                if (response.data.status == 406){
                    console.log("entro al validador de la sesion");
                    this.setState({ nohayremesas: true });
                    this.props.mostrarModal('mensajeUsuario', null, 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
                    new Promise((resolve, reject) => {
                        setTimeout(function(){
                        //localStorage.clear();
                        Auth.signOut();
                        resolve(true);
                        },1500);
                
                    }).then(() => {
                        const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
                        const urlRedirect = window.location.href.substring(0, indexURL);
                        window.location.href = urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
                    });
                }else if(200 === response.status){
                    let remesasFinalizadas = [];
                    if(Object.values(response.data.listaremesas).length > 0){
                        Object.values(response.data.listaremesas).map(item => {
                            Object.values(item).map(dato => {
                                // console.log(dato);
                                remesasFinalizadas.push(dato);   
                                return remesasFinalizadas;
                            });
                            return item;
                        });
                        if(remesasFinalizadas.length > 0 ){
                            this.setState({ nohayremesas: false });
                        }else {
                            this.setState({ nohayremesas: true });
                        }
                    }else{
                        this.setState({ nohayremesas: true });
                    }
                    this.setState({
                        cantidadRemesas: remesasFinalizadas.length,
                        listaRemesas: Object.values(remesasFinalizadas),
                        paginacion: response.data.pagination,
                        pages: parseInt(response.data.pagination.total) % parseInt(response.data.pagination.size) === 0 ? parseInt(parseInt(response.data.pagination.total) / parseInt(response.data.pagination.size),10) : parseInt(parseInt(response.data.pagination.total) / parseInt(response.data.pagination.size),10) + 1
                    }, () => {
                    })
                }
                this.props.ocultarLoading();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }

    onChangeRangoFechas = (fechaInicial, fechaFinal) => {
        this.setState({
            fechaInicial, fechaFinal,
            v_fecha: true,
            formValido: true,
        }, () => {
        });
        localStorage.setItem('fechaInicial', fechaInicial);
        localStorage.setItem('fechaFinal', fechaFinal); 
    }

    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }

    consultarRemesas = () => {
        let request = {
            pageSize: this.state.pageSize,
            page: this.state.page,
            fechaInicio: moment(this.state.fechaInicial).format("DD/MM/YYYY"),
            fechaFin: moment(this.state.fechaFinal).format("DD/MM/YYYY"),
            numeroDocumentoCobro: this.state.numeroDocumentoCobro,
            pagoFacil: this.state.pagoFacil,
            codigoProducto: this.state.codigoProducto,
            poliza: this.state.poliza,
            tipoDocumento: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
            numeroDocumento: this.state.numeroDocumento,
            aseguradoNombre: this.state.aseguradoNombre,
            aseguradoApellido: this.state.aseguradoApellido,
            sortedColumn: this.state.sortedColumn,
            sortedOrder: this.state.sortedOrder,
			banco: this.state.banco.split(CONSTANTES.SEPARADOR)[0],
            canal: this.state.canal.split(CONSTANTES.SEPARADOR)[0],
            subcanal: this.state.subcanal.split(CONSTANTES.SEPARADOR)[0],
			//estadoRemesa: this.state.estadoRemesa.split(CONSTANTES.SEPARADOR)[0],
			riesgo: this.state.riesgo.split(CONSTANTES.SEPARADOR)[0]
        }
        this.obtenerRemesas(request);
    }

    mostrarModal = (casoModal, m_modal) => {
        this.setState({
          casoModal,
          m_modal,
          mostrarModal: true,
        })
      }
    
    exportarCSV = () => {
        
        let request = { 
            fechaInicio: moment(this.state.fechaInicial).format("DD/MM/YYYY"),
            fechaFin: moment(this.state.fechaFinal).format("DD/MM/YYYY"),
            numeroDocumentoCobro: this.state.numeroDocumentoCobro,
            pagoFacil: this.state.pagoFacil,
            codigoProducto: this.state.codigoProducto,
            poliza: this.state.poliza,
            tipoDocumento: this.state.tipoDocumento.split(CONSTANTES.SEPARADOR)[0],
            numeroDocumento: this.state.numeroDocumento,
            aseguradoNombre: this.state.aseguradoNombre,
            aseguradoApellido: this.state.aseguradoApellido,
			exportcsv: "true",
			banco: this.state.banco.split(CONSTANTES.SEPARADOR)[0],
            canal: this.state.canal.split(CONSTANTES.SEPARADOR)[0],
			subcanal: this.state.subcanal.split(CONSTANTES.SEPARADOR)[0],
            estadoRemesa: this.state.estadoRemesa.split(CONSTANTES.SEPARADOR)[0],
            email: this.state.usuario,
			riesgo: this.state.riesgo.split(CONSTANTES.SEPARADOR)[0]
        };
        this.props.mostrarLoading();
        this.props.props.callService("GET","remesas", {...request}, obtenerRemesas).then(response => {
            //console.log(response);
            this.props.ocultarLoading();
                if (response.data.status == 406){
                    this.props.mostrarModal('mensaje', null, 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
                    new Promise((resolve, reject) => {
                        setTimeout(function(){
                        //localStorage.clear();
                        Auth.signOut();
                        resolve(true);
                        },1500);
                
                    }).then(() => {
                        const indexURL = window.location.href.indexOf(CONSTANTES.RUTA.basename);
                        const urlRedirect = window.location.href.substring(0, indexURL);
                        window.location.href = urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
                    });
                }else{
                    let url = response.data.url;
                    if(url == 'glue'){
                        //mensaje de que se le envio al correo
                        this.props.mostrarModal('mensaje', null,'Se le envio un correo con los resultados de busqueda');
                    }else{
                        let identity = localStorage.getItem('identity');
                        //console.log("idennnn:::::", identity); 
                        let ruta = url.replace('private/'+identity+'/', "");
                        //console.log("rutaaa::::" + ruta);
                        Storage.get(ruta,{ 
                            level: 'private', 
                        })
                        .then(result => 
                            {
                                console.log("ressulllttt:::", result);
                                const link = document.createElement('a');
                                link.href = result;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            })
                        .catch(err => console.log(err));
                    }
                }

        }).catch( err => {
            console.log(err);
            this.props.ocultarLoading();
        }); 
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;
        let insertNewFilter = 1;
        if (filtered.length) {
          filtered.forEach((filter, i) => {
            if (filter["id"] === accessor) {
              if (value === "" || !value.length) filtered.splice(i, 1);
              else filter["value"] = value;
    
              insertNewFilter = 0;
            }
          });
        }
        if (insertNewFilter) {
          filtered.push({ id: accessor, value: value });
        }
        this.setState({ filtered: filtered });
    }

    addCommas(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1,$2');
        }
        return x1 + x2;
    }

   
    onPageChange = (page) => {
		if(page >= 0)
		{	this.setState({ page: page, pageSize: this.state.pageSize}, () => {
                this.consultarRemesas();
			}) ;
		}	
    }

    onPageSizeChange = (pageSize) => {
            //var newPages= Math.trunc(this.state.cantidadTransacciones/pageSize) + ((this.state.cantidadTransacciones% pageSize>0)?1:0);
            //if(newPages >= this.state.page){
                this.setState({ page: 0, pageSize: pageSize}, () => {
                    this.consultarRemesas();                    
                }) ;
            //}					
    }
    onSortedChange =  (newSorted, column, shiftKey) => {
        console.log(newSorted);
        console.log(column);
        console.log(shiftKey);
        var columna;
        var order = newSorted[0].desc?'desc':'asc';
        if(newSorted[0].id){
            columna = newSorted[0].id;
        }else{
            if(column.Header == 'Nombre Cliente'){
                columna = `nombreasegurado ${order}, apellidopaternoasegurado ${order}, apellidomaternoasegurado ${order}`;
                order = '';
            }
        }
        this.setState({sortedColumn: columna, sortedOrder: order, sorted:newSorted}, () => {
            this.consultarRemesas();                    
        });
    }

    buscar = () => {
        this.setState({ page: 0, sorted: [], sortedColumn:'', sortedOrder:''}, () => { 
            this.consultarRemesas();
        });
    }

    render(){
        const fontSize = 11;
        const { open, listaRemesas, page } = this.state;
        ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableRemesaHeader', className:'tableRemesaCell'};
        let columns = [{
            id: 'id',
            Header: 'ID',
            accessor: 'id',
            show: false
        }, {
            Header: 'Doc. Identidad',
            accessor: 'numerodocumento',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 80,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'NumId. Cliente',
            accessor: 'numidcliente',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 70,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Nombre Cliente',
            Cell: props => <div style={{ textAlign: "center" }}>{(props.original.nombreasegurado || '') + ' ' + (props.original.apellidopaternoasegurado || '') + ' ' + (props.original.apellidomaternoasegurado || '')}</div>,
            minWidth: 240,
            style: {
                fontSize: fontSize,
            },
        }, /*{
            Header: 'Desc. Producto',
            accessor: 'descripcionproducto',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 147,
            style: {
                fontSize: fontSize,
            },
        },*/ {
            Header: 'Cod. Producto',
            accessor: 'codigoproducto',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 60, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Poliza',
            accessor: 'poliza',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 70,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Tipo Doc. Cobro',
            accessor: 'tipodocumentocobro',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 40, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'N° Doc. Cobro',
            accessor: 'numerodocumentocobro',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 90, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Banco',
            accessor: 'banco',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 260, 
            style: {
                fontSize: fontSize,
            },
        },{
            Header: 'N°Cuenta',
            accessor: 'numerocuenta',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 120, 
            style: {
                fontSize: fontSize,
            },
        },{
            Header: 'Fec. Venc. Doc.',
            accessor: 'fechavencimientodocumento',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 80, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Fec. Envío',
            accessor: 'fechaenvio',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 80, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Moneda Doc.',
            accessor: 'moneda',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 50, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Mto. Doc.',
            accessor: 'monto',
            Cell: props => <div style={{ textAlign: "right" }}>{props.value}</div>,
            minWidth: 60, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Pago Facil',
            accessor: 'pagofacil',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 75, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Desc. Estado.',
            accessor: 'descripcionestado',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 100, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'Detalle',
            accessor: 'id',
            Cell: props => <div style={{ textAlign: "center", fontSize: 10 }}><button type="button" className="btn btn-table btn-primary red" onClick={this.onOpenModal(props.value)}>Detalle</button></div>,
            filterable: false,
            minWidth: 70,
            style: {
                fontSize: fontSize,
            },
        }]
        Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
            if(p.path === '/reportediario'){
                if(p.acciones.detalle !== "true"){
                    columns = columns.filter(e => e.Header !== "Detalle");
                    return columns;
                }
                else
                {
                    return null;
                };
            }
            else
            {
                return null;
            }
        })
        return(
            <div className="w100 d-flex mb-flex-column justify-content-between">
                                <div className={( this.state.buscadorMobile )+" boxBuscar mb-w100 d-flex flex-column flex-justify-between w100"}>
                                <div className="banner banner-white d-flex justify-content-center mb-display-none ">
                                    <div className="boxBanner boxBanner-white d-flex justify-content-between align-items-center">
                                        <div className="tituloBanner">
                                            <p><b>Reporte Diario {this.state.currentCount}</b></p>
                                        </div>
                                    </div>
                                </div>
                                    <div className="seccionFiltrar">
                                        <p className="tituloBuscar" ><span>Filtra </span>tu búsqueda: </p>
                                        {localStorage.getItem("NombreArchivo") != null ?
                                        <p>Nombre Archivo: <b>{localStorage.getItem("NombreArchivo")}</b></p>                                       
                                        : null}                                        
                                        <Row>
                                                <Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaTipoDocumentos}                                                 
                                                        titulo = "Tipo Doc."                                                
                                                        name = "tipoDocumento"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.tipoDocumento}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Tipo Doc.'
                                                        validate = {this.state.v_tipoDocumento}/>
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="numeroDocumento"
                                                        value={this.state.numeroDocumento}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Num. Doc."
                                                        validate = {this.state.v_numeroDocumento}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="aseguradoNombre"
                                                        value={this.state.aseguradoNombre}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Nom. Cliente"
                                                        validate = {this.state.v_aseguradoNombre}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="aseguradoApellido"
                                                        value={this.state.aseguradoApellido}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Ape. Cliente"
                                                        validate = {this.state.v_aseguradoApellido}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="codigoProducto"
                                                        value={this.state.codigoProducto}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Cod. Producto"
                                                        validate = {this.state.v_codigoProducto}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="poliza"
                                                        value={this.state.poliza}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Poliza"
                                                        validate = {this.state.v_poliza}   />
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="numeroDocumentoCobro"
                                                        value={this.state.numeroDocumentoCobro}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="N° Doc. Cob."
                                                        validate = {this.state.v_numeroDocumentoCobro}/>
                                                </Col>
                                                <Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaRiesgo}                                                 
                                                        titulo = "Riesgo"                                                
                                                        name = "riesgo"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.riesgo}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Riesgo'
                                                        validate = {this.state.v_riesgo}/>
                                                </Col>


                                                <Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaCanal}                                                 
                                                        titulo = "Canal"                                                
                                                        name = "canal"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.canal}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Canal'
                                                        validate = {this.state.v_canal}/>
                                                </Col>

                                                <Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaSubCanal}                                                 
                                                        titulo = "Sub Canal"                                                
                                                        name = "subcanal"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.subcanal}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Subcanal'
                                                        validate = {this.state.v_subcanal}/>
                                                </Col>

                                                
												<Col className="s12 m4 l3">
                                                    <Select 
                                                        lista = {this.state.listaBancos}                                                 
                                                        titulo = "Banco"                                                
                                                        name = "banco"
                                                        habilitarValorInicial = {true}
                                                        value = {this.state.banco}
                                                        onChange = {(e) => { 
                                                                            this.onChange(e); 
                                                                            this.validarFormulario(e);
                                                                    }}
                                                        placeholder = 'Banco'
                                                        validate = {this.state.v_banco}/>
                                                </Col>

                                                <Col className="s12 m4 l3">
                                                    <InputText
                                                        name="pagoFacil"
                                                        value={this.state.pagoFacil}
                                                        onBlur={this.validarFormulario} 
                                                        onChange={this.onChange}
                                                        placeholder="Pago Facil"
                                                        validate = {this.state.v_pagoFacil}   />
                                                </Col>
												
                                                <Col className="s12 m4 l3">
													<label className='' htmlFor={'calendarPortalCobranzas'}>Fecha de Busqueda</label>
                                                    <CalendarioRango onChangeRangoFechas={this.onChangeRangoFechas}/>                                    
                                                </Col>
                                        </Row>
                                       
                                        <Row>                                                
                                                <Col className="s12 m4 l3" style={{float: "right"}}>
                                                    {Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                                                            if(p.path === '/reportediario'){
                                                                if(p.acciones.exportar === "true"){
                                                                    return(<button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.exportarCSV} key={key} style={{marginBottom: "10px"}}>Exportar</button>)
                                                                }
                                                                else
                                                                {
                                                                    return null;
                                                                }
                                                            }
                                                            else
                                                            {
                                                                return null;
                                                            }
                                                        })}
                                                </Col>
                                                <Col className="s12 m4 l3" style={{float: "right"}}>
                                                    {Object.values(localStorage.getItem("permisos") ? JSON.parse(localStorage.getItem("permisos")) : "").map((p,key) => {
                                                        if(p.path === '/reportediario'){
                                                            if(p.acciones.buscar === "true"){
                                                                //return(<Boton {...this.props} onClick={this.buscar} key={key}/>)
                                                                return (<button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.buscar} key={key} style={{marginBottom: "10px"}}>Buscar</button>);
                                                            }
                                                            else
                                                            {
                                                                return null;
                                                            }
                                                        }
                                                        else
                                                        {
                                                            return null;
                                                        }
                                                    })}
                                                </Col>
                                        </Row> 
                                        
                                            {/* {window.innerWidth <= 760 ?
                                            <Row>
                                                <Col>
                                                    <button className={"botonFormulario right btn-small no-box-shadow"} onClick={(e) => this.previousPageHandler()}>Regresar</button>
                                                </Col>                                                
                                            </Row> 
                                            : null } */}                                            
                                            <div>
                                                <ReactTable
                                                        defaultPageSize={10}
                                                        data={listaRemesas}
                                                        columns={columns}
                                                        previousText={"Anterior"}
                                                        nextText={"Siguiente"}
                                                        loadingText={"Cargando..."}
                                                        noDataText={"No hay datos para mostrar"}
                                                        pageText={"Página"}
                                                        ofText={"de"}
                                                        rowsText={"filas"}
                                                        pageSizeOptions={[10, 20, 50]}
                                                        manual
                                                        onPageChange={this.onPageChange}
                                                        onPageSizeChange={this.onPageSizeChange}
                                                        page={page}
                                                        pages={this.state.pages}
                                                        sorted={this.state.sorted}
                                                        // onPageChange={page => this.setState({ page })}
                                                        defaultSorted={[{
                                                            id: 'fechaenvio',
                                                            desc: true
                                                        }]}
                                                        onSortedChange={this.onSortedChange}
                                                        //Filtro
                                                        // filterable
                                                        // filtered={this.state.filtered}
                                                        // onFilteredChange={(filtered, column, value) => {
                                                        //     this.onFilteredChangeCustom(value, column.id || column.accessor);
                                                        // }}
                                                        // defaultFilterMethod={(filter, row, column) => {
                                                        //     const id = filter.pivotId || filter.id;
                                                        //     if (typeof filter.value === "object") {
                                                        //     return row[id] !== undefined
                                                        //         ? filter.value.indexOf(row[id]) > -1
                                                        //         : true;
                                                        //     } else {
                                                        //     return row[id] !== undefined 
                                                        //         ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
                                                        //         : true;
                                                        //     }
                                                        // }}
                                                />
                                            </div>              
                                    </div>
                                </div>
                                <Modal open={open} onClose={this.onCloseModal} center>
                                    <div className="boxModalPoliticas">
                                        <div className="headerModalPoliticas">
                                            DETALLE DE REMESA
                                        </div>
                                        <div className="bodyModalPoliticas">                                       
                                            <Editor
                                                value={this.state.listaDetalleRemesas[0]}
												sortObjectKeys={true}
												mode={"view"}
                                            />
                                        </div>
                                    </div>
                                </Modal>
                                <ModalGenerico 
                                    caso={this.state.casoModal}
                                    mostrar={this.state.mostrarModal}
                                    mensaje={this.state.m_modal}
                                    cerrarModal={ () => this.setState({ mostrarModal: false }) } />
                                
            </div>
            
        );
    }
}
export default HOC(Reportediario);